<div class="dark-view">
  <mat-spinner class="spinner"></mat-spinner>
</div>
